const KEY1 = "set:init_config";
const KEY2 = "set:auth_token";
const KEY3 = "set:session_user";
const KEY4 = "set:reg_info";
const KEY5 = "del:session_user";
const KEY6 = "set:client_env";
const KEY7 = "get:category_list"; //创作者分类
const KEY8 = "get:plan_list";
const KEY8_1 = "push:plan_list";
const KEY8_2 = "splice:plan_list";
const KEY8_3 = "set:vip_all_plans";

const KEY27 = "get:plan_sale_list";
const KEY27_1 = "push:plan_sale_list";
const KEY27_2 = "splice:plan_sale_list";

const KEY9 = "set:reset_info";
const KEY10 = "set:dashboard";
const KEY11 = "concat:dashboard_sponsored_history";
const KEY11_1 = "unconcat:dashboard_sponsored_history";
const KEY12 = "set:browser_size";
const KEY13 = "set:redirect_url";
const KEY14 = "set:reg_type";
const KEY15 = "set:unread_message_num";
const KEY16 = "set:session_user.creator.custom_plan";
const KEY17 = "set:notice_bar_key";
const KEY18 = "get:goal_list";
const KEY18_1 = "push:goal_list";
const KEY18_2 = "splice:goal_list";
const KEY18_3 = "set:goal_setting";
const KEY19 = "set:mp_token";
const KEY20 = "set:mp_profile";
const KEY21 = "set:bind_account";
const KEY22 = "set:q";
const KEY23 = "set:unread_count";
const KEY24 = "set:unread_post_num";
const KEY25 = "set:all_pay_types";
const KEY26 = "set:is_applying_apple";
const KEY26_1 = "set:is_applying_google";
const KEY28 = "set:afdian_theme";
const KEY29 = "set:is_show_download";
const KEY30 = "set:is_show_timing";
const KEY31 = "set:video_info";
const KEY32 = "set:search_history";
const KEY33 = "set:visiter_history";
const KEY34 = "del:search_history";
const KEY35 = "del:visiter_history";
const KEY36 = "set:is_full_screen";
const KEY37 = "set:havefun";
const KEY38 = "set:locale_lang";
const KEY39 = "set:bind_wechat_account";



const IS_APPLYING_APPLE = false;
const WHITE_LIST = {
    // APPLYING_APPLE: ["41bf2a62c2f211e8a9fa52540025c377"], //审核账户  179f19102e7111e8bf4d52540025c377
    APPLYING_APPLE: [
        // "41bf2a62c2f211e8a9fa52540025c377",
        // "179f19102e7111e8bf4d52540025c377",
    ], //审核账户
    LINKS: [
        "3477946af5a511eab08752540025c377", //justpod
    ],
    PLANS_ZHANG: [
        "b306bb36eded11eab0c252540025c377", //podFest China
        "b0cccc5ceded11eab9c252540025c377", //podFest China
        "b1ffe988eded11ea953f52540025c377", //podFest China
    ], // 张的plan
    PLANS_SALE: [
        "b306bb36eded11eab0c252540025c377", //podFest China
        "b0cccc5ceded11eab9c252540025c377", //podFest China
        "b1ffe988eded11ea953f52540025c377", //podFest China
    ],
    PLANS_FEN: [
        "37d6a626bc4a11ea9d3852540025c377",
        // "afc95c8cbde411ea8eda52540025c377",
        "3f27c4dec00811eaa8ea52540025c377",
        "0e0f97c8c3aa11ea82ca52540025c377",
        "22d673ccc3a811eaac5652540025c377",
        "3c4d1048c3aa11ea820f52540025c377",
        "f30ef7c4cb0c11ea807a52540025c377",
        "e6d96578e84611ea8d4152540025c377",
        "cc3ef90ef65a11ea90e952540025c377",
        "cee71c4af65a11eaa81152540025c377",
        "bc8fa2bef66f11eaa7cd52540025c377",
        "e81a6772f65911ea8aa452540025c377",
        "ea38b996f65911ea977c52540025c377",
        "67b807f4f66f11ea89ef52540025c377",
        "145ccc0c6c6511e8a33952540025c377",
        "c6fb601cf66a11eaaf6352540025c377",
        "e1e19306f66a11ea9e1152540025c377",
        "defa756af98311ea98ba52540025c377",
        "95568dc6f8a311eaaa4152540025c377",
        "93c143e8f8a311ea9f6552540025c377",
        "2fab20e60cfc11eb9f9752540025c377",
        "34e459f60cb111ebb72e52540025c377",
        "6e22d68e0cb111ebad7e52540025c377",
        "c1f2cb800cb011eb8b1752540025c377",
        "634ad1100d0811eb9c4852540025c377",
        // 'b06dc7841dd611ebb4d252540025c377',
        '9509b156338e11eb8d0952540025c377',
        '8d220570309511eb806e52540025c377',
        '07ec68a4c10b11eaa7d552540025c377',
        '2e61e79c3b9b11eb906d52540025c377',
        '2e46fe2c150e11eb8b0852540025c377',
        '94362a98b21a11ea888752540025c377',
        'e009418c2a5411eba57a52540025c377',
        'b06dc7841dd611ebb4d252540025c377',
        '258eac48695111ebbef452540025c377',
        '82b80b58695111eb90db52540025c377',
        'd7d02386695211eb941352540025c377'
    ], // 份的plan
    PLANS_CUSTOM: [
        "5cd4173ee10111ea87d552540025c377",
        "fcc6a3c6e45b11eaa69052540025c377",
        "3a7388e4ecf711ea8c4d52540025c377",
        "0d125066dab811eaacb352540025c377",
        "7c4ef070dea911eab9a452540025c377",
        "27651dace04111eaa47052540025c377",
        "fb55cce8ef7711eab7ae52540025c377",
        "999a25ccee5411ea9d4252540025c377",
        "78578cc2f0ef11ea914452540025c377",
        "ae2c31caeb3311ea91f352540025c377",
        "54d6281ef12911ea93a352540025c377",
        "ac0b2d20e82111eaa97952540025c377",
        "7392f120f65a11eaaa2252540025c377",
        "579dabb0f65811eab1bc52540025c377",
        "733693726c6311e8bf2a52540025c377",
        "5e6c4aee0f7d11eb917a52540025c377",
        "9cffd93012c311eb905f52540025c377",
        '5f42703e1d8c11eba5ac52540025c377',
        'd55f10641d7911eb9d4952540025c377'
    ], //自定义赞助的 user_id 隐藏选择月份的
    PLANS_YEAR: [
        "a103c78cc4f611ea843652540025c377",
        "d5614f44c4f711eaa99652540025c377",
        "8dc66196c4f811eaa01652540025c377",
        "b5f231e2e84611ea93df52540025c377",
        "fdc8f9f80ed211eb89a052540025c377",
        "02b87afa0f0111ebaa8f52540025c377",
        // "935d906c648411eb876352540025c377"
        // "9128470c2c9d11eb804f52540025c377",
        // "a952a1f62c9d11eb9c2152540025c377",
    ], // 年的plan
    PLANS_Q: [
        // "f814bc2ef1c011ea875152540025c377",
        // "03ddd1f8f1c111eaa78152540025c377",
        // "418b272c648411eba7fe52540025c377",
    ], // 季度的plan
    PLANS_TICKET: [
        "fc439512116f11eb876452540025c377",
        "78ce05340a1a11eb99a552540025c377",
        "fc439512116f11eb876452540025c377",
        "ae69e34e0dd411eb946d52540025c377",
        "94d4f46e0dcf11ebab1b52540025c377",
        "f44e055a0dd111eb829252540025c377",
        '9a0df6a4181711ebb59152540025c377',
        'c095a254181711eb98cd52540025c377',
    ], // 购票 plan
    SINGLE_MONTH:[
        '9509b156338e11eb8d0952540025c377',
        '8d220570309511eb806e52540025c377',
        '07ec68a4c10b11eaa7d552540025c377',
        '2e61e79c3b9b11eb906d52540025c377',
        '2e46fe2c150e11eb8b0852540025c377',
        '94362a98b21a11ea888752540025c377',
        'e009418c2a5411eba57a52540025c377',
    ],// 下单页直接显示单月价格
    ORIGIN_ALBUM_IMG_USERS:[
        '04300c00bc2611eab7cc52540025c377',
        'beaf1482bc2511ea896452540025c377'
    ],//展示原图，不压缩情况的userid
    LIMIT_VIDEO_SIZE_8G_USERS:[
      '27f7cea2370d11e8ae8852540025c377',
      '179f19102e7111e8bf4d52540025c377',
      '0ea2d2d262d611ec9c0852540025c377',
      '7dd267a85cc311ecb82652540025c377'
    ],//feed 上传视频开放 8g
    LIMIT_VIDEO_SIZE_10G_USERS:[
      'a49f38d6428011eda00252540025c377',
      '9a7d14be00f311edbf6352540025c377',
      '179f19102e7111e8bf4d52540025c377',
      '5e74251ec2ce11e8bf7352540025c377',
    ],//feed 上传视频开放 10g
    LIMIT_VIDEO_SIZE_15G_USERS:[
      'f7fedcb27ac411ed978552540025c377',
      '179f19102e7111e8bf4d52540025c377', //me
    ],//feed 上传视频开放 15g
    LIMIT_AUDIO_SIZE_400M_USERS:[
      'de28a438903911ecb24d52540025c377',
      '179f19102e7111e8bf4d52540025c377', //me
      '27f7cea2370d11e8ae8852540025c377' // lain
    ],//feed 上传音频开放 400m
    LIMIT_AUDIO_SIZE_500M_USERS:[
      '5e74251ec2ce11e8bf7352540025c377',
    ],//feed 上传音频开放 500m
    PAYPAL_DOOR_LIST:[
      '15b65f0a1f9411edadd552540025c377',
      '179f19102e7111e8bf4d52540025c377'
    ],//paypal 入口
    PAYPAL_PLAN_IDS:[
      '550937a41f9411edb15a52540025c377',
    ],//paypal 入口
    PLANS_LINGQU:[
      {plan_id:'5d15e526cf8211ec9f2f52540025c377', path:'/redeem/kyockcho'},
      {plan_id:'1479ba6ef6b411ecbf1c52540025c377', path:'/redeem/ikezakimisa'},
      {plan_id:'108c7c2629c111eda5af52540025c377', path:'/redeem/ts2258'},
      {plan_id:'4dd394d267d511edb9eb52540025c377', path:'/redeem/gggrande'},
      {plan_id:'b84d25641ec711ed91cf52540025c377', path:'/redeem/alp315'},
      {plan_id:'e1f228ea29c811ed983252540025c377', path:'/redeem/alde_hyde'},
      {plan_id:'27fb797229c911edab3f52540025c377', path:'/redeem/tamalauncher'},
      {plan_id:'f721aa741d3e11ed95ea52540025c377', path:'/redeem/mutyamutya'},
      {plan_id:'859fa3781d3f11ed984252540025c377', path:'/redeem/kotatsu358'},
      {plan_id:'faac9b8a1d3f11edb58d52540025c377', path:'/redeem/senetoseneto'},
      {plan_id:'7a4869641d4011ed8ad652540025c377', path:'/redeem/24Bllue'},
      {plan_id:'b726f1721ec911ed95ca52540025c377', path:'/redeem/chocolat_cos0'},
      {plan_id:'08a12a025e4b11edbb6252540025c377', path:'/redeem/rikatantan2nd'},
      {plan_id:'a003ccea54fc11edac2e52540025c377', path:'/redeem/u_s_o'},
    ],//直接领取的plan 入口
    PLANS_LIMIT:[
      '500bb6322dc711eda52b52540025c377'
    ],
    VOTE_IMG_USERS:[
      '179f19102e7111e8bf4d52540025c377',
      '6de4661e386611e8955c52540025c377',
      '80a0b7b47ff211ea990952540025c377',
    ],
    WITHDRAW_HIDE_USERS:[
      'c0f523c831c911ed918e52540025c377',
      '634c444a31c911edafeb52540025c377',
      '06ae6b8231c911eda89c52540025c377',
      '98c4e07431c811edb6a152540025c377',
      '3d64bcc231c811edbcdb52540025c377',
      'cf3a6f6231c711ed8fc252540025c377',
      '0e50380431c711eda27d52540025c377',
      'aaa9d4ae31c611edacf652540025c377',
      '39f6685831c611ed97bc52540025c377',
      'b590c82431c511eda2dc52540025c377',
      'c9459fb231c411edbbe452540025c377',
      '4b358e4a032911ecac4652540025c377',
    ],
    // BANK_EDIT_USERS:[
    //   'b26f3bb6fda511ec894952540025c377',
    //   '3e05de28844811ecb07852540025c377',
    //   '7ee11b1ce78411eba02752540025c377',
    //   '33b2cf40d31b11ec9fc052540025c377',
    //   '5968f37ae84211e9959052540025c377',
    //   '52bf4bacff4911ecbbf152540025c377',
    // ]
};

const BLACK_LIST = {
    BAD_REFERRER:[
      'blog.daot.cc',
      'daot.cc'
    ],
    HIDE_FADIAN_COUNT: [
        "46286540c27e11eabc3d52540025c377",
        "ac0b2d20e82111eaa97952540025c377",
        "ea33a51e820111e9a06b52540025c377",
        "d209856e3d3111e8966552540025c377",]
    , //隐藏发电人数
    //   APPLYING_APPLE: [ '41bf2a62c2f211e8a9fa52540025c377' ] //审核账户  179f19102e7111e8bf4d52540025c377
    POSTS: [
      "92aa33b68b4a11e8aa6952540025c377",
      "2da755247a8911e8ad6d52540025c377",
      ], //审核不能看的post
    HIDE_COMMENT_USERS: [
      "25f894145a9011ed88fc52540025c377",
    ], //隐藏评论入口
    NO_PAY_OPTIONS:[
        'a8beb5ccf14111eb99e052540025c377',
        'a2de0554f14111eb834052540025c377',
        'f11211f6ae4911ebb79052540025c377',
        '439179b0541911ec81db52540025c377',
        '567f4340541911ec97a452540025c377',
        '69619a9e541911ec98b752540025c377',
        '73b126aa895111ec959852540025c377'
    ]// plan_id 不在支付页显示价格选项，默认选中 pay_month 的月份
};

import {
    GET_INIT_CONFIG,
    GET_SESSION_USER,
    GET_CATEGORY_EDIT_LIST,
    GET_ALL_PLANS,
    GET_MY_DASHBOARD,
    POST_CREATOR_CUSTOM_PLAN_SWITCH,
    GET_ALL_GOALS,
    GET_MY_ACCOUNT,
} from "../api/config";
import Vue from 'vue'
import * as $http from "../api/fetch";
import env from "../plugin/env";
import $bus from "@/plugin/bus";
export const LIST = {
    WHITE_LIST,
    BLACK_LIST
}

export const state = () => {
    let lang = navigator.language.substring(0, 2);
    // lang = lang == 'zh' ? 'zh-CN' : lang == 'ja' ? 'ja-JA' : 'en-US';
    lang = lang == 'zh' ? 'zh-CN' : 'en-US';
    return {
        init_config: {},
        search_history: localStorage.getItem("search_history") ? localStorage.getItem("search_history").split(',') : [],
        visiter_history: localStorage.getItem("visiter_history") ? localStorage.getItem("visiter_history").split(',') : [],
        locale_lang: localStorage.getItem("locale_lang") || lang,
        host: location.origin,
        reg_type: "", // email  phone
        redirect_url: "",
        auth_token: -1, //3种值  -1 初始化状态； '' 登录失效状态   xxxx：登录态
        mp_token: localStorage.getItem("mp_token") || -1,
        session_user: null,
        mp_profile: null, // 微信用户资料  nickname & headimgurl
        wx_oauth_landpage: env.is_pro ? 'https://afdian.net/oauth/wechat' : 'http://74db138637d611e887f852540025c377.afdian.net/oauth/wechat',
        bind_account: {
            email: "",
            phone: "",
        },
        bind_wechat_account: null,
        user_status: {
            pending: 1, //普通用户
            show: 2, //创作者
            hide: 3,
            ban: 4,
        },
        order_status: {
            pending: 1, //待付款
            success: 2, //付款成功
            cancel: 3, //取消
        },
        plan_status: {
            normal: 1, //赞助计划正常
            delete: 2, //赞助计划删除
            hide: 3, //赞助计划隐藏
        },
        goal_type: {
            sponsor: 1, //赞助者
            money: 2, //金额
            sum_income: 3, //累计金额
        },
        goal_status: {
            normal: 1,
            delete: 2,
            hide: 3,
        },
        custom_plan_status: {
            bottom: 1, // 置底
            top: 2, // 置顶
            hide: 3, // 隐藏
        },
        pay_status: {
            alipay: 1,
            wxpay: 2,
        },
        withdraw_status: {
            waiting: 1,
            success: 2,
            error: 3,
            bank_error: 7,
        },
        all_pay_types: {
            alipay: 1, //支付宝
            wxpay_qr: 1, //微信二维码
            wxpay_h5: 1, //浏览器唤起微信
            wxpay_js: 1, //公众号，微信浏览器登录
            wxpay_mini: 1, //小程序
        },
        pay_list: ["alipay", "wxpay"], // 支付类型配置 'alipay','wxpay'
        // pay_list: [ 'alipay' ], // 支付类型配置 'alipay','wxpay'
        is_client: false, // 在App.vue 中 mounted 后触发为 true
        upload: {
            avatar_url: "/api/upload/avatar",
            img_common_url: "/api/upload/common-pic",
            audio_url: "/api/upload/audio",
            video_url: "/api/upload/video",
            id_card_url:'/api/bang/upload-file',
            name: "file",
            max_file_size: 1024 * 1024 * 10, // 10M
            max_audio_file_size: 1024 * 1024 * 300, // 300M
            max_audio_file_size_400: 1024 * 1024 * 400, // 400M
            max_audio_file_size_500: 1024 * 1024 * 500, // 500M
            max_video_file_size: 1024 * 1024 * 4000, // 4G
            max_video_file_size_8g: 1024 * 1024 * 8000, // 8G
            max_video_file_size_10g: 1024 * 1024 * 10000, // 10G
            max_video_file_size_5g: 1024 * 1024 * 15000, // 15G
        },
        reg_info: {
            name: "",
            acount: "",
            password: "",
        },
        reset_info: {
            acount: "",
            token: "",
        },
        category_list: [], //创作分类
        // create_type: [
        //     { type: 1, name: "个人" },
        //     { type: 2, name: "团体" },
        // ],
        stat_type: [
            { type: 'day', name: "按日统计" },
            { type: 'week', name: "按周统计" },
            { type: 'month', name: "按月统计" },
        ],
        plan_list: [], //赞助
        plan_sale_list: [], //售卖
        vip_all_plans:[],
        goal_list: [], //目标
        goal_setting: {}, //目标设置开关
        dashboard: {
            balance: "",
            total_income: "",
            visit_count: "",
            sponsoring: [],
            sponsored_history: [],
            sponsored_history_total_count: "",
            monthly_bill: [],
            balance_after_tax: "",
            transfer_fee_detail: {},
            sponsoring_expired: [],
            unconfirmed_amount:'',
            confirmed_amount:''
        },
        feed_type: {
            normal: 0,
            article: 1,
        },
        browser_size: "", //App.vue 在维护这里
        unread_message_num: 0,
        unread_post_num: 0,
        notice_bar_key: localStorage.getItem("notice_bar_key"),
        afdian_theme: localStorage.getItem("afdian_theme") || '',
        q: "",
        unread_count: {
            comment: 0,
            message: 0,
        },
        is_applying_apple: env.is_applying_apple,
        is_applying_google: env.is_applying_google,
        white_list: WHITE_LIST,
        black_list: BLACK_LIST,
        is_show_download:true,
        is_show_timing:false,
        video_info:{},
        audio_info:{},
        goodluck:0,
        hotwater:0,
        havefun:0,
        user_feed_setting:{
            sponsoring:0,
            unlock:0,
        },
        is_full_screen:false,
        big_event_gray:[], //大事件黑白主题,配置的是路由 demo: ['feed', 'index']
    };
};
export const mutations = {
    [KEY1](state, val) {
        state.init_config = val;
    },
    [KEY2](state, val) {
        state.auth_token = val;
    },
    [KEY3](state, val) {
        state.session_user = val;
    },
    [KEY4](state, val) {
        state.reg_info = val;
    },
    [KEY5](state) {
        state.session_user = null;
    },
    [KEY6](state) {
        state.is_client = true;
    },
    [KEY7](state, val) {
        state.category_list = val;
    },
    [KEY8](state, val, val2) {
        state.plan_list = [];
        state.plan_list = val;
        state.plan_sale_list = [];
        state.plan_sale_list = val2;
    },
    [KEY8_1](state, val) {
        state.plan_list.push(val);
    },
    [KEY8_2](state, param) {
        state.plan_list.splice(...param);
    },
    [KEY8_3](state, val) {
        state.vip_all_plans = val;
    },
    [KEY27](state, val) {
        state.plan_sale_list = [];
        state.plan_sale_list = val;
    },
    [KEY27_1](state, val) {
        state.plan_sale_list.push(val);
    },
    [KEY27_2](state, param) {
        state.plan_sale_list.splice(...param);
    },
    [KEY9](state, val) {
        state.reset_info = val;
    },
    [KEY10](state, val) {
        state.dashboard = val;
    },
    [KEY11](state, val) {
        state.dashboard.sponsored_history = state.dashboard.sponsored_history.concat(
            val
        );
    },
    [KEY11_1](state, val) {
        state.dashboard.sponsored_history = val.concat(
            state.dashboard.sponsored_history
        );
    },
    [KEY12](state, val) {
        state.browser_size = val;
    },
    [KEY13](state, val) {
        state.redirect_url = val;
    },
    [KEY14](state, val) {
        state.reg_type = val;
    },
    [KEY15](state, val) {
        state.unread_message_num = val;
    },
    [KEY16](state, param) {
        state.session_user.creator.custom_plan = param.status;
        state.session_user.creator.custom_plan_desc = param.desc;
    },
    [KEY17](state, val) {
        state.notice_bar_key = val;
    },
    [KEY18](state, val) {
        state.goal_list = [];
        state.goal_list = val;
    },
    [KEY18_1](state, val) {
        state.goal_list.push(val);
    },
    [KEY18_2](state, param) {
        state.goal_list.splice(...param);
    },
    [KEY18_3](state, val) {
        state.goal_setting = val;
    },
    [KEY19](state, val) {
        state.mp_token = val;
    },
    [KEY20](state, val) {
        state.mp_profile = val;
    },
    [KEY21](state, val) {
        state.bind_account = val;
    },
    [KEY22](state, val) {
        state.q = val;
    },
    [KEY23](state, val) {
        state.unread_count = val;
    },
    [KEY24](state, val) {
        state.unread_post_num = val;
    },
    [KEY25](state, val) {
        for (let i in val) {
            state.all_pay_types[i] = val[i];
        }
    },
    [KEY26](state, val) {
      state.is_applying_apple = val;
    },
    [KEY26_1](state, val) {
      state.is_applying_google = val;
    },
    [KEY28](state, val) {
        state.afdian_theme = val;
    },
    [KEY29](state, val) {
        state.is_show_download = val;
    },
    [KEY30](state, val) {
        state.is_show_timing = val;
    },
    [KEY31](state, val) {
        state.video_info = val;
    },
    [KEY32](state, val) {
        let i = state.search_history.indexOf(val)
        if(i != -1){
            state.search_history.splice(i, 1);
        }
        state.search_history.unshift(val);
        if(state.search_history.length > 10){
            state.search_history.pop()
        }
        localStorage.setItem("search_history", state.search_history.join(','));
    },
    [KEY33](state, val) {
        let i = state.visiter_history.indexOf(val)
        if(i != -1){
            state.visiter_history.splice(i, 1);
        }
        state.visiter_history.unshift(val);
        if(state.visiter_history.length > 3){
            state.visiter_history.pop()
        }
        localStorage.setItem("visiter_history", state.visiter_history.join(','));
    },
    [KEY34](state, val) {
        state.search_history = [];
        localStorage.removeItem("search_history");
    },
    [KEY35](state, val) {
        state.visiter_history = [];
        localStorage.removeItem("visiter_history");
    },
    [KEY36](state, val) {
        state.is_full_screen = val;
    },
    [KEY37](state, val) {
        state.havefun = val;
    },
    [KEY38](state, val) {
        state.locale_lang = val;
        localStorage.setItem("locale_lang", val);
    },
    [KEY39](state, val) {
      state.bind_wechat_account = val;
    },
};

export const actions = {
    async [KEY1]({ commit }) {
        if ($http.is_run(GET_INIT_CONFIG)) {
            return false;
        }
        let data = await $http.$axios(GET_INIT_CONFIG);
        if (data.ec == 200) {
            localStorage.setItem("init_config", JSON.stringify(data.data));
            commit(KEY1, data.data);
        }
    },
    [KEY2]({ commit }, auth_token = "") {
        commit(KEY2, auth_token);
    },
    async [KEY3]({ commit }) {
        if ($http.is_run(GET_SESSION_USER)) {
            return false;
        }
        let data = await $http.$axios(GET_SESSION_USER);
        if (data.ec == 200) {
            commit(KEY3, data.data.user);
            commit(KEY25, data.data.user.all_pay_types);
            localStorage.setItem('user_id', data.data.user.user_id);
            if (
                //goodluck == 1 or 申请app store 时候的开关
                data.data.goodluck == 1 ||
                IS_APPLYING_APPLE &&
                ((env.is_afd_client && env.is_ios) ||
                    env.is_iPad ||
                    (navigator.userAgent.indexOf("Macintosh") != -1 && !env.is_chrome))
            ) {
                commit(KEY26, true);
            }
            if (data.data.hotwater == 1 && env.is_channel_google) { //hotwater == 1 or 申请google play 时候的开关
                commit(KEY26_1, true);
            }
            if(data.data.havefun == 1){
                commit(KEY37, 1);
            }

            if(data.data.ip_info != undefined){ //只有国外访问才会有
              Vue.set(env,'is_abroad', data.data.ip_info.is_abroad)
            }
        }
    },
    [KEY4]({ commit }, reg_info = {}) {
        commit(KEY4, reg_info);
    },
    [KEY5]({ commit }) {
        commit(KEY5);
    },
    [KEY6]({ commit }) {
        commit(KEY6);
    },
    async [KEY7]({ commit }) {
        if ($http.is_run(GET_CATEGORY_EDIT_LIST)) {
            return false;
        }
        let data = await $http.$axios(GET_CATEGORY_EDIT_LIST);
        if (data.ec == 200) {
            commit(KEY7, data.data.list);
        }
    },

    async [KEY8]({ commit },post_data = {}) {
        if ($http.is_run(GET_ALL_PLANS)) {
            return false;
        }
        let data = await $http.$axios(GET_ALL_PLANS, post_data);
        if (data.ec == 200) {
            let list = data.data.list;
            list = list.length == 0 ? [{config:{}}] : list;
            commit(KEY8, list);

            let list2 = data.data.sale_list;
            list2 = list2.length == 0 ? [{config:{}}] : list2;
            commit(KEY27, list2);

            if(data.data.vip_all_plans){
                commit(KEY8_3, data.data.vip_all_plans);
            }
        }
    },
    [KEY8_1]({ commit }, plan = {}) {
        commit(KEY8_1, plan);
    },
    [KEY8_2]({ commit }, param) {
        commit(KEY8_2, param);
    },
    [KEY27_1]({ commit }, plan = {}) {
        commit(KEY27_1, plan);
    },
    [KEY27_2]({ commit }, param) {
        commit(KEY27_2, param);
    },
    [KEY9]({ commit }, reset_info = {}) {
        commit(KEY9, reset_info);
    },
    async [KEY10]({ commit }, dashboard = {}) {
        if ($http.is_run(GET_MY_DASHBOARD)) {
            return false;
        }
        let data = await $http.$axios(GET_MY_DASHBOARD);
        if (data.ec == 200) {
            commit(KEY10, data.data);
        }
    },
    [KEY11]({ commit }, list = []) {
        commit(KEY11, list);
    },
    [KEY11_1]({ commit }, list = []) {
        commit(KEY11_1, list);
    },
    [KEY12]({ commit }, new_size = "") {
        commit(KEY12, new_size);
    },
    [KEY13]({ commit }, redirect_url = "") {
        commit(KEY13, redirect_url);
    },
    [KEY14]({ commit }, reg_type = "") {
        commit(KEY14, reg_type);
    },
    [KEY15]({ commit }, unread_message_num = 0) {
        commit(KEY15, unread_message_num);
    },
    async [KEY16]({ commit }, param) {
        if ($http.is_run(POST_CREATOR_CUSTOM_PLAN_SWITCH)) {
            return false;
        }
        let data = await $http.$axios(POST_CREATOR_CUSTOM_PLAN_SWITCH, {
            status: param.status,
            desc: param.desc,
        });
        if (data.ec == 200) {
            commit(KEY16, param);
        }
        return data;
    },
    [KEY17]({ commit }, notice_bar_key = "") {
        commit(KEY17, notice_bar_key);
    },

    async [KEY18]({ commit }) {
        if ($http.is_run(GET_ALL_GOALS)) {
            return false;
        }
        let data = await $http.$axios(GET_ALL_GOALS);
        if (data.ec == 200) {
            let list = data.data.list;
            // list = list.length == 0 ? [{}] : list;
            commit(KEY18, list);
            if(data.data.goal_setting){
                commit(KEY18_3, data.data.goal_setting);
            }
        }
    },
    [KEY18_1]({ commit }, goal = {}) {
        commit(KEY18_1, goal);
    },
    [KEY18_2]({ commit }, param) {
        commit(KEY18_2, param);
    },
    [KEY19]({ commit }, mp_token = -1) {
        localStorage.setItem("mp_token", mp_token + "");
        commit(KEY19, mp_token);
    },
    [KEY20]({ commit }, mp_profile = null) {
        commit(KEY20, mp_profile);
    },
    async [KEY21]({ commit }) {
        if ($http.is_run(GET_MY_ACCOUNT)) {
            return false;
        }
        let data = await $http.$axios(GET_MY_ACCOUNT);
        // if (data.ec != 200) {
        //     this.$notify({
        //         title: data.em,
        //         group: "error",
        //     });
        //     return false;
        // }
        commit(KEY21, data.data.login);
        if(data.data.oauth && data.data.oauth.wechat){
          commit(KEY39, data.data.oauth.wechat);
        }
    },
    [KEY22]({ commit }, q = "") {
        commit(KEY22, q);
    },
    [KEY23]({ commit }, val = {}) {
        commit(KEY23, val);
    },
    [KEY24]({ commit }, val = 0) {
        commit(KEY24, val);
    },
    [KEY25]({ commit }, val = 0) {
        commit(KEY25, val);
    },
    [KEY26]({ commit }, val = 0) {
        commit(KEY26, val);
    },
    [KEY26_1]({ commit }, val = 0) {
      commit(KEY26_1, val);
    },
    [KEY28]({ commit }, val = 0) {
        commit(KEY28, val);
    },
    [KEY29]({ commit }, val = 0) {
        commit(KEY29, val);
    },
    [KEY30]({ commit }, val = 0) {
        commit(KEY30, val);
    },
    [KEY31]({ commit }, val = {}) {
        commit(KEY31, val);
    },
    [KEY32]({ commit }, val = {}) {
        commit(KEY32, val);
    },
    [KEY33]({ commit }, val = {}) {
        commit(KEY33, val);
    },
    [KEY34]({ commit }, val = {}) {
        commit(KEY34, val);
    },
    [KEY35]({ commit }, val = {}) {
        commit(KEY35, val);
    },
    [KEY36]({ commit }, val = {}) {
        commit(KEY36, val);
    },
    [KEY37]({ commit }, val = {}) {
      commit(KEY37, val);
    },
    [KEY38]({ commit }, val = {}) {
      commit(KEY38, val);
    },
    [KEY39]({ commit }, val = {}) {
      commit(KEY39, val);
    },
};


export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
